import React, {useEffect, useLayoutEffect} from "react";
import styled from "styled-components";
import {useNavigate, useNavigationType} from "react-router";
import {batch, useDispatch, useSelector} from "react-redux";
import {
	fetchDetailBranchPageScroll,
	fetchReceivableInfo,
	updateBranchReceivableInfoList
} from "redux/slices/sales/salesSlice";

import {getToday} from "utils/date";
import {getCommaNumber} from "utils/format";
import iconChevron from "assets/icons/icon_chevron_black.svg";

import Observer from "components/ui/Observer";



/**
 * [전지점 누적 미수금 목록]
 */

export const BranchDetailList = () => {
	const today = getToday();
	const dispatch = useDispatch();
	const navigate = useNavigate();
	const navigationType = useNavigationType();
	const {
		searchPartner,
		searchBranch,
		searchDate,
		data,
		dataList,
		page,
		pageState
	} = useSelector(state => state.sales.branchReceivableInfo);

	useEffect(() => {
		const isUpdate = (
			!data || navigationType != "POP" || (
				searchPartner != data.searchInfo.searchPartner ||
				searchBranch != data.searchInfo.searchBranch ||
				today != data.searchInfo.searchDate
			)
		);
		if(isUpdate) {
			if(pageState != undefined) {
				dispatch(updateBranchReceivableInfoList(false));
			}
		}
	}, [searchPartner, searchBranch]);

	useLayoutEffect(() => {
		if(navigationType == "POP") {
			dispatch(fetchDetailBranchPageScroll("restore"));
		}
	}, []);

	const eventHandler = {
		update : function() {
			dispatch(updateBranchReceivableInfoList(true));
		},
		detail : (searchBranch) => {
			batch(() => {
				dispatch(fetchReceivableInfo({
					searchPartner : searchPartner,
					searchBranch : searchBranch,
					searchDate : searchDate
				}));
				navigate("/sales/receivable/" + searchBranch);
			});
		}
	};

	// 본점(seqPartnerBranch 0)은 주문 API에서 전 지점 조회가 되어 금액과 맞지 않으므로 상세로 넘기지 않는다
	const isHeadOffice = (item) => item.seqPartnerBranch === 0 || item.seqPartnerBranch === "0";

	const getReceivableList = () => {
		let li = (dataList || []).map((item, index) => {
			return (
				<li key={item.seqPartnerBranch || index}>
					<a
						className={isHeadOffice(item) ? "static" : undefined}
						onClick={isHeadOffice(item) ? undefined : () => {eventHandler.detail(item.seqPartnerBranch)}}
					>
						<div>
							{item.partnerName}
							<span>{getCommaNumber(item.occurCount)}건</span>
						</div>
						<div>{getCommaNumber(item.receivables)}원</div>
					</a>
				</li>
			);
		});
		if(!li.length && pageState == false) {
			li = <li className="empty">조회된 내역이 없습니다.</li>
		}
		return (<ul className="color">{li}</ul>);
	};

	return (
		<Wrapper className="color">
			{getReceivableList()}
			<Observer isActive={pageState} isLoading={true} onVisible={eventHandler.update} />
		</Wrapper>
	);
};

const Wrapper = styled.div`
&								{padding:0 24px}
ul 								{font-size:var(--18px); font-weight:600}
ul li a							{display:flex; justify-content:space-between; padding:24px 0; line-height:1.3}
ul li + li						{border-top:1px solid var(--lightBorder)}
li div span						{font-size:var(--14px); font-weight:400; color:var(--gray)}
li div span:before				{content:" · "}
li div + div					{padding-right:1em; background:url(${iconChevron}) no-repeat center right}
li a.static div + div			{padding-right:0; background:none}
li.empty						{padding:20px 0; border:none; text-align:center; opacity:0.66}
`;

export default BranchDetailList;